module.exports = __webpack_public_path__ + "static/img/demand.de0a229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/demand.png
// module id = DFuF
// module chunks = 2